import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';

if (process.env.NODE_ENV === 'development') {
  import('react-grab').catch(() => {});
}

const root: ReactDOM.Root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
